import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem as MenuItemMui } from '@mui/material';
import './MenuItem.module.scss';
export function MenuItem(props) {
    return _jsx(MenuItemMui, Object.assign({ className: 'con-menu-item' }, props));
}
